import { Vector2, Vector3 } from 'three';
import { IPoint2d } from './IPoint2d';
import { IPoint3d } from './IPoint3d';

export class VectorPointUtils {
  private constructor() {}

  static vectorToPoint(vec: Vector2): IPoint2d;
  static vectorToPoint(vec: Vector3): IPoint3d;
  static vectorToPoint(vec: Vector2 | Vector3) {
    if (vec instanceof Vector3) {
      return { x: vec.x, y: vec.y, z: vec.z };
    } else {
      return { x: vec.x, y: vec.y };
    }
  }
  static pointToVector(point: IPoint2d): Vector2;
  static pointToVector(point: IPoint3d): Vector3;
  static pointToVector(point: IPoint2d | IPoint3d) {
    if ('z' in point) {
      return new Vector3(point.x, point.y, point.z);
    } else {
      return new Vector2(point.x, point.y);
    }
  }
}
